import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useIntl } from 'react-intl';

function useCompanyInfo(companyInfo, customText) {
    const [isOpenDialogCompanyInfo, setIsOpenDialogCompanyInfo] = useState(false);
    const [companyInfoView, setCompanyInfoView] = useState([]);
    const intl = useIntl();

    useEffect(() => {
        if (!_.isEmpty(companyInfo)) {
            setCompanyInfoView([
                { value: companyInfo.full_name, label: customText?.field_name?.exhibitor_name || intl.formatMessage({ id: 'register.exhibitionName' }) },
                { value: companyInfo.company_type, label: customText?.field_name?.industry_type || intl.formatMessage({ id: 'industryType' }) },
                { value: companyInfo.zip_code, label: customText?.field_name?.zip_code || intl.formatMessage({ id: 'zipCode' }) },
                { value: companyInfo.address, label: customText?.field_name?.address || intl.formatMessage({ id: 'address' }) },
                { value: companyInfo.phone_number, label: customText?.field_name?.phone_number || intl.formatMessage({ id: 'phoneNumber' }) },
                { value: companyInfo.fax_number, label: customText?.field_name?.fax_number || intl.formatMessage({ id: 'exhibition.fax' }) },
                { value: companyInfo.url, label: customText?.field_name?.url || 'ＵＲＬ' },
                { value: companyInfo.description, label: customText?.field_name?.info_guide || intl.formatMessage({ id: 'register.guideInfo' }) },
            ]);
        }
    }, [companyInfo, customText]);

    return {
        isOpenDialogCompanyInfo,
        companyInfoView,
        setIsOpenDialogCompanyInfo,
    };
}

export default useCompanyInfo;
